<!--
 * @Author: your name
 * @Date: 2020-08-14 14:19:26
 * @LastEditTime: 2020-09-27 21:23:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/DishesInfo/index.vue
-->
<style scoped lang="sass">
.dishes_info
  display: flex
  flex-direction: column
  padding-bottom: 16px
  background-color: #fff

  .info
    display: flex
    flex-direction: column

    .price
      font-size: 14px
      color: var(--menu-primary-text-colour)

    .info_text
      margin-top: 16px
      padding-right: 21px
      font-size: 12px
      line-height: 18px
      color: var(--menu-primary-text-colour)

</style>

<template lang="pug">
.dishes_info
  .info
    span.price.ls3(v-if="price") {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ convertedPrice }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
    p.info_text.o {{ info }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  props: {
    price: {
      type: [String, Number]
    },
    info: {
      type: [String]
    }
  },
  computed: {
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    convertedPrice() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return formatDecimalNumber(convertPrice(parseFloat(this.price)))
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})
class DishesInfo extends Vue {
}

export default DishesInfo
</script>
